// The toppers account/utility side-nav shell shared by the auth documents (and
// reused by the account documents): the capped-width wrapper, the
// customer-service side nav (when the NavBar snippet exists), and the content
// title. The content title renders the
// content_title partial's "Talk to Sleep Expert" phone line (the
// customer-service phone, resolved server-side via account_title_phone). The
// side nav SSRs with the first desktop link_list expanded (expandFirstLinkList
// default) and self-manages its accordion toggles (selfManaged): toppers has
// retired the global `.accordion` click handler, so the side nav owns its own
// open/close state.
import { Immutable } from "immer";
import React from "react";
import { AccountContentTitle } from "tsi-common-react/src/apps/customer-account/AccountContentTitle/index";
import { SideNav } from "tsi-common-react/src/apps/customer-account/SideNav/index";

import { templates } from "@reactivated";

type IProps = Immutable<{
    hasNav: boolean;
    sideNav: templates.PasswordResetDocumentTemplate["side_nav"];
    title: string;
    phoneDisplay: string;
    phoneHref: string;
}> & {
    children?: React.ReactNode;
};

export const AccountShell = (props: IProps): React.JSX.Element => (
    <div className="l-capped-width u-margin-bottom--xl u-full-width-title">
        {props.hasNav && (
            <div className="l-side-nav">
                <SideNav items={props.sideNav} selfManaged={true} />
            </div>
        )}

        <div className="l-side-nav-content">
            <AccountContentTitle
                contentTitle={props.title}
                phoneDisplay={props.phoneDisplay}
                phoneHref={props.phoneHref}
            />

            <div className="content__copy--full-width">{props.children}</div>
        </div>
    </div>
);
